// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3kE0M","header":"MessagesList_header__7JDGl","chat":"MessagesList_chat__1v_s-"};